import PropTypes from "prop-types";

import styled from "styled-components/macro";

import FnrIcon from "UI/FnrIcon";
import FnrTypography from "UI/FnrTypography";

export default function ListTitle({ title, icon }) {
  return (
    <ListTitleWrapper>
      {/* <FnrIcon
        icon={icon}
        style={{
          textShadow: "rgba(0, 0, 0, 0.5) 1px 1px 2px",
          fontSize: ".75em",
        }}
      /> */}
      <FnrTypography
        shadow
        letterSpacing=".05rem"
        color="white"
        fontSize=".75em"
        style={{
          textTransform: "uppercase",
          fontFamily: '"Merriweather", serif',
        }}
      >
        {title}
      </FnrTypography>
    </ListTitleWrapper>
  );
}

ListTitle.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

const ListTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: white;
  margin-left: 10px;
  margin-bottom: -8px;
`;
